
import Vue from 'vue'

export default Vue.extend({
   name: 'CurrencyboxFormGroup',
   props: {
      id: String,
      label: String,
      value: Number,
      symbol: { type: String, default: '$' },
      code: { type: String, default: '' },
      placeholder: { type: String, default: '' },
      required: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      validate: { type: Boolean, default: false },
      instructions: { type: String, default: '' },
   },
   data() {
      return {
         initialValue: 0,
         innerValue: '0.00',
         dirty: false,
      }
   },
   computed: {
      validationFailed(): boolean {
         if (!this.required) {
            return false
         }
         if (!this.validate && !this.dirty) {
            return false
         }
         return !this.innerValue
      },

      helpBlock(): string {
         return `A value for ${this.label} is required`
      },
   },
   mounted() {
      this.innerValue = this.value.toFixed(2)
      this.initialValue = this.value
   },
   watch: {
      value(newValue: number) {
         if (newValue !== +this.innerValue) {
            this.innerValue = newValue.toFixed(2)
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = +this.innerValue !== this.value
         }
         this.$emit('input', +this.innerValue)
      },
   },
   components: {},
})
